import { TableConfig } from '@shared/interfaces/table/table-config';
import { ChargeInformationPriceStatusDto } from '@app/api/dmc';
import {DateCellComponent} from '@shared/components/table/cells/date-cell/date-cell.component';
import {StatusCellComponent} from '@shared/components/table/cells/status-cell/status-cell.component';
import {LinkCellComponent} from '@shared/components/table/cells/link-cell/link-cell.component';
import {TranslateCellComponent} from '@shared/components/table/cells/translate-cell/translate-cell.component';


export const priceStatusTableConfig: TableConfig<ChargeInformationPriceStatusDto> = {
  id: 'table-dashboard-locked-metered-data',
  exportable: true,
  columns: [
    {
      title: 'dashboard.pricestatus.status',
      key: 'priceStatus',
      width: '120',
      cellRenderer: StatusCellComponent,
      cellRendererParams: {
        red: {label: 'Problem', color: 'bg-red-500'},
        yellow: {label: 'Warning', color: 'bg-yellow-500'},
        green: {label: 'OK', color: 'bg-green-500'}
      }
    },
    {
      title: 'dashboard.pricestatus.chargeTypeId',
      key: 'chargeTypeID',
      cellRenderer: LinkCellComponent,
      cellRendererParams: {
        url: '/chargeinformation',
        urlReference: 'chargeInformationDeltaId'
      }
    },
    {
      title: 'dashboard.pricestatus.name',
      key: 'chargeInformationName'
    },
    {
      title: 'dashboard.pricestatus.nextGap',
      key: 'priceAvailableDate',
      cellRenderer: DateCellComponent
    },
    {
      title: 'dashboard.pricestatus.priceslater',
      key: 'pricesAvailableAfterDate',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        false: 'common.no',
        true: 'common.yes'
      }
    }
  ]
}
